var l={light:"300",normal:"400",medium:"500",bolder:"600",bold:"700"};export{l as default};
//# sourceMappingURL=fontWeight.module.scss.js.map
